import styled from 'styled-components'
import {media} from '../../theme/config'

export const MiddleBarStyled = styled.div`
  height: 56px;
  padding: 0 20px;
  background-color: ${props => props.theme.colors.others.middleBar};
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  &:after {
    content:"";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    background-image: ${props => props.theme.colors.primary.gradient};
    height: 2px;
    width: 100%;
  }
  @media ${media.mobileL} {
    height: 76px;
    padding: 0 15px 0 20px;
    &:after {
      content:"";
      background-image: none;
    }
  }
`

export const LogoWrapper = styled.a`
  margin-right: auto;
  @media ${media.mobileL} {
    margin-right: 25px;
  }
  @media ${media.tablet} {
    margin-right: 50px;
  }
`

export const Logo = styled.img`
  display: block;
  height: 30px;
  @media ${media.mobileL} {
    height: 35px;
  }
  @media ${media.tablet} {
    height: 45px;
  }
  @media ${media.desktop} {
    height: 55px;
  }
`

export const MiddleBarButton = styled.button`
  border: 0;
  padding: 5px;
  background: transparent;
  appearance: none;
  display: flex;
  justify-content: center;
  cursor: pointer;
  position: relative;
  
  &:first-child {
    margin-right: 15px;
  }
  
  &:not(:first-of-type) {
    margin-left: 10px;
  }
`

export const SecurityIcons = styled.div`
  display: ${({showIcons}) => (showIcons ? 'block' : 'none')};
  white-space: nowrap;
  
  a:first-child {
    margin-left: 30px;
  }

  img {
    height: 46px;
    width: auto;
  }
  
  span {
    display: inline-block;
    margin-left: 15px;
  }
`
